import { Select } from "antd";
import {
  getMarkedDepthTradingCompanies,
  getTradingCompanies,
} from "api/teamRunApi";
import { GlobalContext } from "contexts/GlobalContext";
import { useContext, useEffect, useState } from "react";

function CompanyTraders({
  value,
  onChange,
  setTradingCompanyId,
  defaultValue,
  placeholder,
  isPopup = false,
  isBidAndAsk = false,
  isDisabled = false,
  rowID,
  onClear,
  companyTraders,
  isTradingCompaniesLoading,
  minWidth,
  isAllowClear = true,
  id,
  setRefetchCompanies,
  refetchCompanies,
  productId,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [tradingCompanies, setTradingCompanies] = useState([]);

  useEffect(() => {
    if (!companyTraders) {
      fetchTradingCompanies();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (refetchCompanies) {
      fetchTradingCompanies();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetchCompanies]);
  
  const fetchTradingCompanies = async () => {
    setIsLoading(true);
    try {
      const response = isBidAndAsk
        ? await getMarkedDepthTradingCompanies(rowID, isBidAndAsk, productId)
        : await getTradingCompanies({product_id: productId});
      setTradingCompanies(response.data.data);
      setIsLoading(false);
      if (setRefetchCompanies) setRefetchCompanies(false);
    } catch (error) {
      setRefetchCompanies(false);
      setIsLoading(false);
    }
  };

  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);

  return (
    <Select
      placeholder={placeholder || "Trading Companies"}
      allowClear={isAllowClear}
      onClear={() => {
        if (!isPopup) {
          setTradingCompanyId(null);
        } else {
          onClear?.();
        }
      }}
      value={isTradingCompaniesLoading || isLoading ? null : value || null}
      onChange={(v) => {
        const label = [...(companyTraders || tradingCompanies)]?.find(
          (item) => item?.id === v
        )?.label;
        if (!isPopup) {
          onChange(id, label, v);
          setTradingCompanyId(v);
        } else {
          onChange(v);
        }
      }}
      disabled={isLoading || isDisabled || isTradingCompaniesLoading}
      showSearch
      filterOption={(input, option) => {
        const inputSmallLetter = input.toLowerCase();
        const label = option.children.toLowerCase();
        return label.includes(inputSmallLetter);
      }}
      defaultValue={isLoading ? null : defaultValue}
      loading={isLoading || isTradingCompaniesLoading}
      style={{ width: isPopup ? "100%" : 180, minWidth: minWidth }}
      size={isPopup ? "middle" : "middle"}
      className={
        dark_Theme
          ? "select-dark edit-company-trader-input"
          : "edit-company-trader-input"
      }
      popupClassName={dark_Theme ? "dropdown-dark" : ""}
    >
      {[...(companyTraders || tradingCompanies)].map((item) => (
        <Select.Option key={item.id} value={item.id}>
          {item?.label}
        </Select.Option>
      ))}
    </Select>
  );
}

export default CompanyTraders;
